// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"88ae8d8f","678":"d69a1799"}[chunkId] + ".chunk.js";
};